<template lang="pug">
.property-page
  .container-fluid.property-page-title
    .container
      p.title-path
        router-link(to="/properties") {{ $t("property_page.property_list_top") }}
        span#arrow-delimiter >
        span {{ $t("property_page.rent_assessment") }}
      p.title-property-name
        span {{ $t("property_page.rent_assessment") }}
  .container-fluid.property-details
    .container(v-if="!isEmpty(property)")
      property-details(:property="property")
      annual-income(:property="property")
      rooms-table(
        :property="property"
        :rooms="property.rooms"
        :needs_fee_update="property.room_needs_fee_update"
        @onCheckedRoom="passCheckedRooms"
      )
      changes-in-past-rent(v-if="isExistingAndRoomsPresent()", :checkedRooms="checkedRooms", :property="property")
</template>

<script>
import {api} from '@/api'
import PropertyDetails from '@/pages/Property/Page/property-details'
import AnnualIncome from '@/pages/Property/Page/annual-income'
import RoomsTable from '@/pages/Property/Page/rooms-table'
import ChangesInPastRent from '@/pages/Property/Page/changes-in-past-rent'
import { isEmpty } from 'lodash'

export default {
  components: {
    PropertyDetails,
    AnnualIncome,
    RoomsTable,
    ChangesInPastRent
  },
  
  data(){
    return {
      property: {},
      checkedRooms: []
    }
  },

  created() {
    api.get('properties/' + this.$route.params.id).then(({ data: { data } }) => {
      this.property = data
      this.initRoomsIDS()
      this.generateColorsForRooms()
    })
  },
  methods: {
    isEmpty,

    passCheckedRooms(checkedRooms) {
      this.checkedRooms = checkedRooms
    },

    initRoomsIDS() {
      this.property.rooms.forEach(room => {
        this.checkedRooms.push(room.id)
      });
    },

    isExistingAndRoomsPresent() {
      return this.property.existing && this.property.rooms.length > 0
    },

    generateColorsForRooms() {
      const rooms = this.property.rooms.map(room => {
        const color = '#' + Math.random().toString(16).slice(2, 8)
        return { ...room, color }
      })
      this.property = { ...this.property, rooms }
    }
  }
}
</script>

<style lang="scss" scoped>
.property-page {
  padding-bottom: 100px;

  .property-page-title {
    align-items: center;
    background: #fff;
    box-shadow: 0 2px 16px 0 rgba(176, 186, 197, 0.2);
    display: flex;
    font-weight: 700;
    height: 112px;
    margin-bottom: 10px;

    .title-path {
      a,
      span {
        color: #7c91a7;
        font-size: 11px;
        letter-spacing: 0;
      }

      a:hover {
        color: #7c91a7;
        text-decoration: none;
      }

      #arrow-delimiter {
        margin: 0 5px;
      }
    }

    .title-property-name {
      color: #3d4a57;
      font-size: 30px;
      letter-spacing: 0;
    }
  }

  .property-details {
    background: #fcfdfe;
  }
}
</style>
